import { motion } from 'framer-motion';

const ImpactCard = ({ value, label, icon: Icon }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="text-center p-6"
      data-testid={`impact-card-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {Icon && (
        <div className="inline-flex items-center justify-center p-3 rounded-full bg-primary/10 mb-4">
          <Icon className="h-6 w-6 text-primary" />
        </div>
      )}
      <div className="text-4xl md:text-5xl font-bold text-gradient font-['Outfit'] mb-2">
        {value}
      </div>
      <div className="text-sm text-muted-foreground uppercase tracking-wider">
        {label}
      </div>
    </motion.div>
  );
};

export default ImpactCard;
